"use strict";
var Goal = (function () {
    function Goal(id, teamId, gameId, playerId, time, gameState) {
        this.id = id;
        this.teamId = teamId;
        this.gameId = gameId;
        this.playerId = playerId;
        this.time = time;
        this.gameState = gameState;
    }
    return Goal;
}());
exports.Goal = Goal;



/*****************
 ** WEBPACK FOOTER
 ** ./src/goal.ts
 ** module id = 60
 ** module chunks = 1
 **/